import { initRatingForm } from "Functions/rating";
import { Vue, i18n } from "Common/vue";
import ShippingInfo from "VueComponents/ShippingInfo.vue";
import Ratings from "VueComponents/Ratings.vue";
import { initAnchors } from "Functions/anchor";
import { initProductMarginsTooltip } from "Functions/tippy";
import { checkMaxStock } from "Functions/stock";

import initializeVueProductVariations from "Components/vue/productVariations/utils/initializeVueProductVariations";
import { initializeVariationsDynamicElements } from "Components/vue/productVariations/utils/variationsDynamicElements";

import "Layouts/default";

import "Ui/slider";
import "Ui/toggle";
import "Ui/more-items";
import "Ui/star-rating";
import "Ui/collapsible-content";
import "Common/wishlist";

import "Common/social";
import "Common/lightgallery";

import "Components/modal/modal-remote";
import "Components/modal/modal-watchdog";

import "./product-jquery";

initRatingForm();
initAnchors();

if (document.querySelector(".js-ratings-box")) {
    window.$_ratings = new Vue({
        i18n,
        render: (h) => h(Ratings),
    }).$mount(".js-ratings-box");

    document.querySelectorAll(".js-trigger-rating-filter").forEach((trigger) => {
        trigger.addEventListener("click", (event) => {
            const starsNumber = trigger.dataset.starsNumber;
            const ratingsCount = trigger.dataset.ratingsCount;

            rEvent.dispatch("Rating.triggerFilter", starsNumber, ratingsCount);
        });
    });
}

document.querySelectorAll('[data-has-component="shippingInfo"]').forEach((element) => {
    new Vue({
        el: element,
        components: {
            ShippingInfo,
        },
    });

    element.removeAttribute("data-has-component");
});

initProductMarginsTooltip();

initializeVueProductVariations();

document.addEventListener("DOMContentLoaded", () => {
    initializeVariationsDynamicElements();
});

// Measure unit

const tabs = document.querySelector("#measure-buy-tabs");
const perCarton = tabs.dataset.perCarton || 1;

// Ks
const ksForm = document.querySelector("#ks-form");
const ksSpinner = document.querySelector(".ks-quantity-counter .c-quantity-form");
const ksSubmitButton = document.querySelector(".c-ks-buy-btn");
const ksTabButton = document.querySelector(".js-ks-tab");

// Carton
const ktForm = document.querySelector("#kt-form");
const ktSpinner = document.querySelector(".kt-quantity-counter .c-quantity-form");
const ktSubmitButton = document.querySelector(".c-kt-buy-btn");
const ktTabButton = document.querySelector(".js-kt-tab");

ktSubmitButton.addEventListener("click", () => {
    ksSubmitButton.click();
});

// Updating the values
const onKsChange = (e) => {
    const ksQuantity = e.target.value.split(" ")[0];
    const maxStock = e.target.querySelector(".c-form__input").dataset.stock;
    const cartonQuantity = ksQuantity / perCarton;
    const formattedCartonQuantity =
        cartonQuantity < 1 ? cartonQuantity.toFixed(1) : cartonQuantity.toFixed(1);

    // Set new value for ktSpinner
    ktSpinner.value = `${formattedCartonQuantity} kt`;

    checkMaxStock(ksQuantity, maxStock);
};

const onKtChange = (e) => {
    const ktQuantity = e.target.value.split(" ")[0];
    const maxStock = e.target.querySelector(".c-form__input").dataset.stock;
    const ksQuantity = Math.round(ktQuantity * perCarton);
    const formattedKsQuantity = ksQuantity.toFixed(0);

    // Set new value for ksSpinner
    ksSpinner.value = `${formattedKsQuantity} ks`;

    checkMaxStock(ksQuantity, maxStock);
};

const handleChangeToKt = () => {
    const ksQuantity = ksSpinner.value.split(" ")[0];
    const maxStock = ksSpinner.querySelector(".c-form__input").dataset.stock;
    const cartonQuantity = ksQuantity == 1 ? 1 : ksQuantity / perCarton;
    const formattedCartonQuantity =
        cartonQuantity < 1 ? cartonQuantity.toFixed(1) : cartonQuantity.toFixed(1);

    // Set new value for ktSpinner
    ktSpinner.value = `${formattedCartonQuantity} kt`;

    // Recalculate ks from kt to ensure proper rounding
    const recalculatedKs = Math.round(formattedCartonQuantity * perCarton);
    ksSpinner.value = `${recalculatedKs} ks`;

    checkMaxStock(recalculatedKs, maxStock);
};

const handleChangeToKs = () => {
    const ktQuantity = ktSpinner.value.split(" ")[0];
    const maxStock = ksSpinner.querySelector(".c-form__input").dataset.stock;
    const ksQuantity = Math.round(ktQuantity * perCarton);
    const formattedKsQuantity = ksQuantity.toFixed(0);

    // Set new value for ksSpinner
    ksSpinner.value = `${formattedKsQuantity} ks`;

    checkMaxStock(ksQuantity, maxStock);
};

ksSpinner.addEventListener("stop", onKsChange);
ksSpinner.addEventListener("changed", onKsChange);

if (ksTabButton) {
    ksTabButton.addEventListener("click", handleChangeToKs);
}

if (ktSpinner) {
    ktSpinner.addEventListener("stop", onKtChange);
    ktSpinner.addEventListener("changed", onKtChange);
}

if (ktTabButton) {
    ktTabButton.addEventListener("click", handleChangeToKt);
}
